export enum Locales {
  En = 'en',
  EnUS = 'en-US',
  Es = 'es',
  Fr = 'fr',
}
